import React from 'react';

export default function StickyActionBar({ left = null, right = null, className = '' }) {
  return (
    <footer className={`sticky bottom-0 z-20 bg-[rgba(10,17,28,0.92)] px-6 py-3 backdrop-blur-xl ${className}`}>
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div>{left}</div>
        <div className="flex items-center gap-2">{right}</div>
      </div>
    </footer>
  );
}
